import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { Activity } from '@/models/Activity';
import { publicApi } from '@/utils/api';

type ActivityResponse = {
  data: Activity[];
  paging: {
    next: string;
    pageItemLimit: number;
    totalItemCount?: number;
  };
};

const useLatestActivities = (enabled: boolean, limit: number, next?: string): UseQueryResult<ActivityResponse> =>
  useQuery({
    queryKey: ['activities', limit, next],

    queryFn: async () => {
      const { data } = await publicApi.get<ActivityResponse>(
        `/v0.1/me/activities?limit=${limit}${next ? `&next=${next}` : ''}`,
      );

      return data;
    },

    enabled,
  });

export default useLatestActivities;
